export default __webpack_public_path__ + "static/blog-4-75b66cc2193d66abdadd9d1d813e9f69.jpg";